export default {
  mynews_check_news:'0602Web-查看消息',
  mynews_show_news_list:'0601Web-显示消息列表',
  mynews_web_news:'06Web-消息',
  mynews_go_learn:'立即前往該課程學習嗎？',
  mynews_go_Live:'立即前往該直播嗎？'
}
